// Which refactored features are switched on, read from VITE_REFACTORED_FEATURES (comma-separated,
// e.g. "quotations,vessels"). VITE_* values are baked in at build time, so changing a flag means
// rebuilding and redeploying.
const enabledFeatures = new Set(
  (import.meta.env.VITE_REFACTORED_FEATURES || '')
    .split(',')
    .map((name) => name.trim())
    .filter(Boolean)
)

/** @param {string} name feature folder name, e.g. 'quotations' */
export const isFeatureEnabled = (name) => enabledFeatures.has(name)
